 (function () {
 if (customElements.get('eb-collection-grid')) return;

 class EbCollectionGrid extends HTMLElement {
  constructor() {
   super();
   this.handleClick = this.handleClick.bind(this);
   this.handleChange = this.handleChange.bind(this);
   this.handleInput = this.handleInput.bind(this);
   this.handleSubmit = this.handleSubmit.bind(this);
   this.handleOver = this.handleOver.bind(this);
   this.handleOut = this.handleOut.bind(this);
   this.handleKey = this.handleKey.bind(this);
   this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
   if (this.ebReady) return;
   if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true });
    return;
   }
   this.ebReady = true;
   this.sid = this.dataset.sectionId;
   this.drawer = this.querySelector('[data-eb-drawer]');
   this.form = this.drawer ? this.drawer.querySelector('[data-eb-form]') : null;
   this.qa = this.querySelector('[data-eb-qa-panel]');
   this.toastEl = this.querySelector('[data-eb-toast]');
   this.productCache = this.productCache || {};
   this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

   [this, this.drawer, this.qa].forEach((el) => {
    if (!el) return;
    el.addEventListener('click', this.handleClick);
    el.addEventListener('change', this.handleChange);
    el.addEventListener('input', this.handleInput);
    el.addEventListener('submit', this.handleSubmit);
   });
   this.addEventListener('mouseover', this.handleOver);
   this.addEventListener('mouseout', this.handleOut);
   document.addEventListener('keydown', this.handleKey);
   window.addEventListener('resize', this.handleResize);

   // Le tiroir est déplacé à la racine de la page pour ne jamais être rogné par un parent.
   if (this.drawer) document.body.appendChild(this.drawer);
   if (this.qa) document.body.appendChild(this.qa);
   if (this.toastEl) document.body.appendChild(this.toastEl);

   this.setupSwatchScrollers();
   this.setupInfinite();
  }

  disconnectedCallback() {
   if (!this.ebReady) return;
   this.ebReady = false;
   [this, this.drawer, this.qa].forEach((el) => {
    if (!el) return;
    el.removeEventListener('click', this.handleClick);
    el.removeEventListener('change', this.handleChange);
    el.removeEventListener('input', this.handleInput);
    el.removeEventListener('submit', this.handleSubmit);
   });
   this.removeEventListener('mouseover', this.handleOver);
   this.removeEventListener('mouseout', this.handleOut);
   document.removeEventListener('keydown', this.handleKey);
   window.removeEventListener('resize', this.handleResize);
   if (this.io) this.io.disconnect();
   // Le tiroir revient dans la section : il disparaît avec elle ou la suit si elle est déplacée.
   if (this.drawer) {
    this.drawer.classList.remove('is-open');
    this.appendChild(this.drawer);
   }
   if (this.qa) {
    this.qa.classList.remove('is-open');
    this.qa.hidden = true;
    this.appendChild(this.qa);
   }
   if (this.toastEl) this.appendChild(this.toastEl);
   document.body.classList.remove('ebg-lock');
  }

  /* ---------- Événements ---------- */
  handleClick(e) {
   const t = e.target;
   if (t.closest('[data-eb-open]')) return this.openDrawer();
   if (t.closest('[data-eb-close]')) return this.closeDrawer();

   if (this.qa && this.qa.contains(t)) {
    if (t.closest('[data-eb-qa-close]')) return this.closeQa();
    const step = t.closest('[data-qa-step]');
    if (step) {
     const input = this.qa.querySelector('[data-qa-qty]');
     const v = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.qaStep));
     input.value = v;
     return;
    }
    const add = t.closest('[data-qa-add]');
    if (add) {
     const qty = Math.max(1, parseInt(this.qa.querySelector('[data-qa-qty]').value, 10) || 1);
     if (this.qaVariant) this.addToCart(this.qaVariant.id, qty, add);
    }
    return;
   }

   const qaBtn = t.closest('[data-eb-qa]');
   if (qaBtn) {
    e.preventDefault();
    return this.openQuickAdd(qaBtn);
   }

   const nav = t.closest('[data-eb-nav]');
   if (nav) {
    e.preventDefault();
    return this.load(nav.href);
   }

   const more = t.closest('[data-eb-more]');
   if (more) {
    e.preventDefault();
    return this.loadMore(more);
   }

   const dot = t.closest('.ebg-sw__dot');
   if (dot) {
    e.preventDefault();
    return this.selectSwatch(dot);
   }

   const arrow = t.closest('[data-eb-sw-prev], [data-eb-sw-next]');
   if (arrow) {
    e.preventDefault();
    const track = arrow.parentElement.querySelector('.ebg-sw__track');
    const dir = arrow.hasAttribute('data-eb-sw-next') ? 1 : -1;
    track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.8, 40), behavior: 'smooth' });
   }
  }

  handleChange(e) {
   const t = e.target;
   if (this.qa && this.qa.contains(t) && t.matches('[data-qa-opt]')) return this.qaSync();
   if (t.matches('[data-eb-sort]')) return this.apply();
   if (this.form && this.form.contains(t) && t.type === 'checkbox') return this.apply();
  }

  handleInput(e) {
   const t = e.target;
   if (!this.form || !this.form.contains(t) || t.type !== 'number') return;
   clearTimeout(this.priceTimer);
   this.priceTimer = setTimeout(() => this.apply({ keepForm: true }), 700);
  }

  handleSubmit(e) {
   if (e.target !== this.form) return;
   e.preventDefault();
   this.apply().then(() => this.closeDrawer());
  }

  handleKey(e) {
   if (e.key !== 'Escape') return;
   if (this.qa && this.qa.classList.contains('is-open')) return this.closeQa();
   if (this.drawer && this.drawer.classList.contains('is-open')) this.closeDrawer();
  }

  handleResize() {
   clearTimeout(this.resizeTimer);
   this.resizeTimer = setTimeout(() => this.setupSwatchScrollers(), 150);
  }

  handleOver(e) {
   if (!this.canHover) return;
   const dot = e.target.closest('.ebg-sw__dot');
   if (!dot) return;
   const sw = dot.closest('.ebg-sw');
   if (sw && sw.dataset.preview === 'false') return;
   this.preview(dot);
  }

  handleOut(e) {
   if (!this.canHover) return;
   const sw = e.target.closest('.ebg-sw');
   if (!sw || (e.relatedTarget && sw.contains(e.relatedTarget))) return;
   this.restore(sw.closest('[data-eb-card]'));
  }

  /* ---------- Pastilles ---------- */
  preview(dot) {
   const card = dot.closest('[data-eb-card]');
   const img = card && card.querySelector('.ebg-img--main');
   if (!img || !dot.dataset.src) return;
   if (!img.dataset.origSrc) {
    img.dataset.origSrc = img.getAttribute('src') || '';
    img.dataset.origSrcset = img.getAttribute('srcset') || '';
   }
   if (dot.dataset.srcset) img.setAttribute('srcset', dot.dataset.srcset);
   img.setAttribute('src', dot.dataset.src);
   img.removeAttribute('loading');
   card.classList.add('is-previewing');
  }

  restore(card) {
   if (!card) return;
   const chosen = card.querySelector('.ebg-sw__dot[data-chosen="true"]');
   if (chosen) return this.preview(chosen);
   const img = card.querySelector('.ebg-img--main');
   if (img && img.dataset.origSrc) {
    if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
    img.setAttribute('src', img.dataset.origSrc);
   }
   card.classList.remove('is-previewing');
  }

  selectSwatch(dot) {
   if (this.dataset.swatchClick === 'navigate' && dot.dataset.url) {
    window.location.href = dot.dataset.url;
    return;
   }
   const card = dot.closest('[data-eb-card]');
   card.querySelectorAll('.ebg-sw__dot').forEach((d) => {
    const on = d === dot;
    d.setAttribute('aria-pressed', on ? 'true' : 'false');
    d.dataset.chosen = on ? 'true' : 'false';
   });
   if (dot.dataset.url) {
    card.querySelectorAll('[data-eb-link]').forEach((a) => {
     if (!a.classList.contains('ebg-sw__more')) a.href = dot.dataset.url;
    });
   }
   this.preview(dot);
  }

  setupSwatchScrollers() {
   this.querySelectorAll('.ebg-sw--scroll').forEach((sw) => {
    const track = sw.querySelector('.ebg-sw__track');
    if (!track) return;
    const update = () => {
     const over = track.scrollWidth > track.clientWidth + 2;
     sw.classList.toggle('has-overflow', over);
     const prev = sw.querySelector('[data-eb-sw-prev]');
     const next = sw.querySelector('[data-eb-sw-next]');
     if (prev) prev.disabled = track.scrollLeft <= 2;
     if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    if (!track.dataset.ebBound) {
     track.addEventListener('scroll', update, { passive: true });
     track.dataset.ebBound = '1';
    }
    update();
   });
  }

  /* ---------- Ajout rapide au panier ---------- */
  rootUrl() {
   const r = this.dataset.root || '/';
   return r.endsWith('/') ? r : `${r}/`;
  }

  esc(str) {
   return String(str == null ? '' : str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  }

  money(cents) {
   const v = Number(cents || 0) / 100;
   const fmt = this.dataset.moneyFormat || '[amount_with_comma_separator] €';
   const num = (dec, th, ds) => {
    const parts = v.toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
   };
   let out = fmt.replace(/(?:\{\{|\[)\s*(amount\w*)\s*(?:\}\}|\])/, (m, key) => {
    switch (key) {
     case 'amount_no_decimals': return num(0, ',', '.');
     case 'amount_with_comma_separator': return num(2, '.', ',');
     case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
     case 'amount_with_space_separator': return num(2, ' ', ',');
     case 'amount_with_period_and_space_separator': return num(2, ' ', '.');
     case 'amount_with_apostrophe_separator': return num(2, "'", '.');
     default: return num(2, ',', '.');
    }
   });
   if (this.dataset.euroSpace === 'true') out = out.replace(/\s?€/, ' €');
   return out;
  }

  imgUrl(src, width) {
   if (!src) return '';
   const s = src.startsWith('//') ? `https:${src}` : src;
   try {
    const u = new URL(s, window.location.origin);
    u.searchParams.set('width', width);
    return u.toString();
   } catch (e) {
    return s;
   }
  }

  async getProduct(handle) {
   if (this.productCache[handle]) return this.productCache[handle];
   const res = await fetch(`${this.rootUrl()}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
   if (!res.ok) throw new Error('product');
   const data = await res.json();
   this.productCache[handle] = data;
   return data;
  }

  async openQuickAdd(btn) {
   if (!this.qa) return;
   const handle = btn.dataset.handle;
   if (btn.dataset.single === 'true' && this.dataset.qaDirect === 'true') {
    return this.addToCart(btn.dataset.variant, 1, btn);
   }
   const card = btn.closest('[data-eb-card]');
   let wanted = null;
   const link = card && card.querySelector('.ebg-card__link, [data-eb-link]');
   if (link) {
    const m = (link.getAttribute('href') || '').match(/[?&]variant=(\d+)/);
    if (m) wanted = Number(m[1]);
   }
   this.qaOpener = btn;
   const body = this.qa.querySelector('[data-eb-qa-body]');
   body.innerHTML = '<div class="ebg-qa__skeleton" aria-hidden="true"></div>';
   this.openQa();
   try {
    const product = await this.getProduct(handle);
    this.renderQa(product, wanted);
   } catch (err) {
    window.location.href = `${this.rootUrl()}products/${handle}`;
   }
  }

  openQa() {
   this.qa.hidden = false;
   document.body.classList.add('ebg-lock');
   requestAnimationFrame(() => {
    this.qa.classList.add('is-open');
    const panel = this.qa.querySelector('.ebg-qa__panel');
    if (panel) panel.focus();
   });
  }

  closeQa() {
   if (!this.qa || this.qa.hidden) return;
   this.qa.classList.remove('is-open');
   document.body.classList.remove('ebg-lock');
   clearTimeout(this.qaTimer);
   this.qaTimer = setTimeout(() => {
    this.qa.hidden = true;
   }, 320);
   if (this.qaOpener && this.qaOpener.focus) this.qaOpener.focus();
  }

  renderQa(p, wanted) {
   const L = this.qa.dataset;
   this.qaProduct = p;
   const variants = p.variants || [];
   let v = variants.find((x) => x.id === wanted) || variants.find((x) => x.available) || variants[0];
   const single = variants.length <= 1 && p.options && p.options.length === 1 && /^(title|titre)$/i.test(p.options[0].name || p.options[0]);
   const chev = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
   const opts = single
    ? ''
    : (p.options || [])
       .map((o, i) => {
        const name = typeof o === 'string' ? o : o.name;
        const values = (typeof o === 'string' ? [] : o.values) || [];
        const list = values.length ? values : [...new Set(variants.map((x) => x.options[i]))];
        const optionsHtml = list
         .map((val) => `<option value="${this.esc(val)}"${v && v.options[i] === val ? ' selected' : ''}>${this.esc(val)}</option>`)
         .join('');
        return `<label class="ebg-qa__opt"><span>${this.esc(name)}</span><span class="ebg-qa__select"><select data-qa-opt data-idx="${i}">${optionsHtml}</select>${chev}</span></label>`;
       })
       .join('');
   const imgs = (p.images || []).slice(0, 2);
   const media = imgs.map((src, i) => `<img src="${this.imgUrl(src, 700)}" alt="${i === 0 ? this.esc(p.title) : ''}" data-qa-img="${i}" loading="lazy">`).join('');
   const icon = (this.qa.querySelector('[data-eb-qa-icon]') || {}).innerHTML || '';
   this.qa.querySelector('[data-eb-qa-body]').innerHTML = `
    <div class="ebg-qa__media">${media}</div>
    <div class="ebg-qa__info">
     <div class="ebg-qa__head">
      <div class="ebg-qa__thumb">${imgs[0] ? `<img src="${this.imgUrl(imgs[0], 200)}" alt="" data-qa-thumb>` : ''}</div>
      <div>
       <p class="ebg-qa__title">${this.esc(p.title)}</p>
       <p class="ebg-qa__price" data-qa-price></p>
       <p class="ebg-qa__stock" data-qa-stock></p>
      </div>
     </div>
     ${opts}
     <div class="ebg-qa__actions">
      <div class="ebg-qa__qty">
       <button type="button" data-qa-step="-1" aria-label="Diminuer la quantité">−</button>
       <input type="number" min="1" value="1" inputmode="numeric" data-qa-qty aria-label="Quantité">
       <button type="button" data-qa-step="1" aria-label="Augmenter la quantité">+</button>
      </div>
      <button type="button" class="ebg-qa__add" data-qa-add>${icon}<span data-qa-add-label>${this.esc(L.lAdd)}</span></button>
     </div>
     <p class="ebg-qa__msg" data-qa-msg role="alert"></p>
     ${L.lDetails ? `<a class="ebg-qa__details" href="${this.esc(p.url)}">${this.esc(L.lDetails)}</a>` : ''}
    </div>`;
   this.qaSetVariant(v);
  }

  qaSync() {
   const p = this.qaProduct;
   if (!p) return;
   const chosen = Array.from(this.qa.querySelectorAll('[data-qa-opt]')).map((s) => s.value);
   const v = (p.variants || []).find((x) => chosen.every((val, i) => x.options[i] === val));
   this.qaSetVariant(v || null);
  }

  qaSetVariant(v) {
   const L = this.qa.dataset;
   const p = this.qaProduct;
   this.qaVariant = v && v.available ? v : null;
   const priceEl = this.qa.querySelector('[data-qa-price]');
   const stockEl = this.qa.querySelector('[data-qa-stock]');
   const add = this.qa.querySelector('[data-qa-add]');
   const label = this.qa.querySelector('[data-qa-add-label]');
   const msg = this.qa.querySelector('[data-qa-msg]');
   if (msg) msg.textContent = '';
   const ref = v || p;
   const price = v ? v.price : p.price;
   const compare = v ? v.compare_at_price : p.compare_at_price;
   priceEl.innerHTML = `<span>${this.money(price)}</span>${compare && compare > price ? `<s>${this.money(compare)}</s>` : ''}`;
   if (!v) {
    stockEl.textContent = L.lUnavailable;
    stockEl.classList.add('is-out');
    add.disabled = true;
    label.textContent = L.lUnavailable;
   } else if (!v.available) {
    stockEl.textContent = L.lSoldout;
    stockEl.classList.add('is-out');
    add.disabled = true;
    label.textContent = L.lSoldout;
   } else {
    stockEl.textContent = L.lInstock;
    stockEl.classList.remove('is-out');
    add.disabled = false;
    label.textContent = L.lAdd;
   }
   const vImg = ref && ref.featured_image ? ref.featured_image.src : null;
   if (vImg) {
    const main = this.qa.querySelector('[data-qa-img="0"]');
    const thumb = this.qa.querySelector('[data-qa-thumb]');
    if (main) main.src = this.imgUrl(vImg, 700);
    if (thumb) thumb.src = this.imgUrl(vImg, 200);
   }
  }

  async addToCart(id, qty, btn) {
   if (!id) return;
   const L = this.qa ? this.qa.dataset : {};
   btn.classList.add('is-loading');
   try {
    const res = await fetch(`${this.rootUrl()}cart/add.js`, {
     method: 'POST',
     headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
     body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || L.lError || '');
    const cart = await fetch(`${this.rootUrl()}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    this.updateCartCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('eb:cart:added', { detail: { items: data.items || [data], cart } }));
    this.closeQa();
    this.showToast();
   } catch (err) {
    const msg = this.qa && this.qa.querySelector('[data-qa-msg]');
    if (msg && !this.qa.hidden) msg.textContent = (err && err.message) || L.lError || '';
    else window.location.href = `${this.rootUrl()}cart`;
   } finally {
    btn.classList.remove('is-loading');
   }
  }

  updateCartCount(count) {
   document.querySelectorAll('cart-icon').forEach((el) => {
    if (typeof el.renderCartBubble === 'function') el.renderCartBubble(count);
   });
   document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach((el) => {
    el.textContent = count;
   });
  }

  showToast() {
   const el = this.toastEl;
   const L = this.qa ? this.qa.dataset : {};
   if (!el) return;
   el.innerHTML = `<span>✓ ${this.esc(L.lAdded || '')}</span><a href="${this.esc(this.dataset.cartUrl || '/cart')}">${this.esc(L.lViewcart || '')}</a>`;
   el.hidden = false;
   requestAnimationFrame(() => el.classList.add('is-show'));
   clearTimeout(this.toastTimer);
   this.toastTimer = setTimeout(() => {
    el.classList.remove('is-show');
    setTimeout(() => {
     el.hidden = true;
    }, 300);
   }, 4000);
  }

  /* ---------- Tiroir ---------- */
  openDrawer() {
   if (!this.drawer) return;
   this.lastFocus = document.activeElement;
   this.drawer.classList.add('is-open');
   document.body.classList.add('ebg-lock');
   const opener = this.querySelector('[data-eb-open]');
   if (opener) opener.setAttribute('aria-expanded', 'true');
   const panel = this.drawer.querySelector('.ebg-drawer__panel');
   if (panel) setTimeout(() => panel.focus(), 50);
  }

  closeDrawer() {
   if (!this.drawer) return;
   this.drawer.classList.remove('is-open');
   document.body.classList.remove('ebg-lock');
   const opener = this.querySelector('[data-eb-open]');
   if (opener) opener.setAttribute('aria-expanded', 'false');
   if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  }

  /* ---------- Chargement (tri, filtres, voir plus) ---------- */
  buildUrl() {
   const base = (this.form && this.form.getAttribute('action')) || window.location.pathname;
   const params = new URLSearchParams();
   if (this.form) {
    new FormData(this.form).forEach((v, k) => {
     if (v !== '') params.append(k, v);
    });
   }
   const sort = this.querySelector('[data-eb-sort]');
   if (sort) params.set('sort_by', sort.value);
   const qs = params.toString();
   return qs ? `${base}?${qs}` : base;
  }

  apply(opts = {}) {
   return this.load(this.buildUrl(), opts);
  }

  async fetchSection(url) {
   const u = new URL(url, window.location.origin);
   u.searchParams.set('section_id', this.sid);
   if (this.controller) this.controller.abort();
   this.controller = new AbortController();
   const res = await fetch(u.toString(), { signal: this.controller.signal });
   const html = await res.text();
   const doc = new DOMParser().parseFromString(html, 'text/html');
   return doc.querySelector('eb-collection-grid');
  }

  async load(url, opts = {}) {
   const results = this.querySelector('[data-eb-results]');
   if (results) results.classList.add('is-loading');
   try {
    const fresh = await this.fetchSection(url);
    if (!fresh) {
     window.location.href = url;
     return;
    }
    const freshResults = fresh.querySelector('[data-eb-results]');
    if (results && freshResults) results.replaceWith(freshResults);

    ['[data-eb-count]', '[data-eb-fcount]'].forEach((sel) => {
     const a = this.querySelector(sel);
     const b = fresh.querySelector(sel);
     if (a && b) a.replaceWith(b);
    });

    const freshDrawer = fresh.querySelector('[data-eb-drawer]');
    if (this.drawer && freshDrawer) {
     const ac = this.drawer.querySelector('[data-eb-apply-count]');
     const bc = freshDrawer.querySelector('[data-eb-apply-count]');
     if (ac && bc) ac.textContent = bc.textContent;
     if (!opts.keepForm) {
      const body = this.drawer.querySelector('[data-eb-fbody]');
      const nb = freshDrawer.querySelector('[data-eb-fbody]');
      if (body && nb) {
       const open = Array.from(body.querySelectorAll('details[data-idx]'))
        .filter((d) => d.open)
        .map((d) => d.dataset.idx);
       body.innerHTML = nb.innerHTML;
       body.querySelectorAll('details[data-idx]').forEach((d) => {
        if (open.includes(d.dataset.idx)) d.open = true;
       });
      }
     }
    }

    window.history.replaceState(window.history.state, '', url);
    this.setupSwatchScrollers();
    this.setupInfinite();
   } catch (err) {
    if (err && err.name === 'AbortError') return;
    window.location.href = url;
   } finally {
    const r = this.querySelector('[data-eb-results]');
    if (r) r.classList.remove('is-loading');
   }
  }

  async loadMore(btn) {
   if (btn.classList.contains('is-loading')) return;
   btn.classList.add('is-loading');
   try {
    const fresh = await this.fetchSection(btn.href);
    const grid = this.querySelector('[data-eb-grid]');
    const footer = this.querySelector('[data-eb-footer]');
    if (!fresh || !grid) {
     window.location.href = btn.href;
     return;
    }
    fresh.querySelectorAll('[data-eb-item]').forEach((li) => grid.appendChild(li));
    const freshFooter = fresh.querySelector('[data-eb-footer]');
    if (footer) {
     if (freshFooter) footer.replaceWith(freshFooter);
     else footer.remove();
    }
    this.setupSwatchScrollers();
    this.setupInfinite();
   } catch (err) {
    if (err && err.name === 'AbortError') return;
    window.location.href = btn.href;
   }
  }

  setupInfinite() {
   if (this.io) this.io.disconnect();
   if (this.dataset.infinite !== 'true' || !('IntersectionObserver' in window)) return;
   const btn = this.querySelector('[data-eb-more]');
   if (!btn) return;
   this.io = new IntersectionObserver(
    (entries) => {
     if (entries[0].isIntersecting) {
      this.io.disconnect();
      this.loadMore(btn);
     }
    },
    { rootMargin: '600px 0px' }
   );
   this.io.observe(btn);
  }
 }

 customElements.define('eb-collection-grid', EbCollectionGrid);
})();